<form [formGroup]="parentForm">
  <mat-form-field>
    <mat-label *ngIf="showTitle">{{ title || 'Currency' }}</mat-label>

    <ng-container *ngIf="type === 'autocomplete'; else selectTmpl">
      <input
        type="text"
        placeholder="{{
          showPlaceholder ? 'Type Currency or Country Name' : ''
        }}"
        aria-label="Number"
        matInput
        (blur)="blur()"
        [formControl]="searchCtrl"
        [matAutocomplete]="auto"
        required
      />
      <mat-autocomplete
        (opened)="isDropdownOpen = true"
        (closed)="isDropdownOpen = false"
        #auto="matAutocomplete"
        (optionSelected)="selected($event)"
      >
        <mat-option
          *ngFor="let currency of filteredCurrencies$ | async"
          [value]="currency.currencyCode"
        >
          <ng-container *ngIf="!currency.isMajorCurrency; else majorTmpl"
            >{{ currency.currencyTitle }} ({{
              currency.countryName
            }})</ng-container
          >
          <ng-template #majorTmpl>
            {{ currency.currencyTitle }}
            <!-- - {{ currency.currencyFullName }} -->
          </ng-template>
        </mat-option>
      </mat-autocomplete>
    </ng-container>

    <ng-template #selectTmpl>
      <mat-select
        [(value)]="selected"
        [formControl]="formCtrl"
        (selectionChange)="changed()"
        (openedChange)="selectPanelToggled($event)"
      >
        <mat-option
          *ngFor="let curr of filteredCurrencies$ | async"
          [value]="curr.currencyCode"
        >
          {{ curr.currencyTitle }}
        </mat-option>
      </mat-select>
    </ng-template>
  </mat-form-field>
</form>
